import { changeSearchParamByKey, changeSearchParamsPairsByKey } from '@skytech/utils'
import type { SortingMode } from '@skytech/utils'
import { useLocation, useNavigate } from 'react-router-dom'

export const useSearchParamsByKey = (queryString: string, defaultValue?: string) => {
  const navigate = useNavigate()
  const location = useLocation()

  return changeSearchParamByKey({
    queryString,
    defaultValue,
    search: location.search,
    navigate,
  })
}

export const useSortParams = <T extends string>(
  defaultSortingMode?: SortingMode,
  defaultSortById?: T
) => {
  const navigate = useNavigate()
  const location = useLocation()

  const [searchParamPairs, setSearchParamPairs] = changeSearchParamsPairsByKey({
    paramPairs: [
      { queryString: 'sort', defaultValue: defaultSortingMode || 'off' },
      { queryString: 'sortBy', defaultValue: defaultSortById },
    ],
    search: location.search,
    navigate,
  })

  function handleSort(id: T, sortMode: SortingMode) {
    setSearchParamPairs([
      { queryString: 'sort', value: sortMode },
      { queryString: 'sortBy', value: id },
    ])
  }
  function resetSort() {
    setSearchParamPairs([
      { queryString: 'sort', value: '' },
      { queryString: 'sortBy', value: '' },
    ])
  }

  return [
    {
      querySort: searchParamPairs.sort.value,
      querySortBy: searchParamPairs.sortBy.value,
    },
    { setSearchParamPairs, handleSort, resetSort },
  ] as const
}
